<template>
  <div class="search-filters-tabs">
    <div class="search-filters-tabs__options">
      <button
        v-tag:useractionevent="{
          action: 'select',
          category: 'search results page',
          ecommerce: undefined,
          event: 'uaevent',
          event_detail: productsLabel,
          event_name: 'sub_menu_select',
          label: productsLabel,
        }"
        :class="['search-filters-tabs__options-btn', { 'search-filters-tabs__options-btn--active' : displayingProducts }]"
        @click="displayProductsTab()"
      >
        {{ productsLabel }}
        <span v-if="productsCount">
          ({{ productsCount }})
        </span>
      </button>
      <button
        v-tag:useractionevent="{
          action: 'select',
          category: 'search results page',
          ecommerce: undefined,
          event: 'uaevent',
          event_detail: articlesLabel,
          event_name: 'sub_menu_select',
          label: articlesLabel,
        }"
        :class="['search-filters-tabs__options-btn', { 'search-filters-tabs__options-btn--active' : !displayingProducts }]"
        @click="displayArticlesTab()"
      >
        {{ articlesLabel }}
        <span v-if="articlesCount">
          ({{ articlesCount }})
        </span>
      </button>
    </div>

    <div class="search-filters-tabs__content">
      <div v-show="displayingProducts">
        <slot name="products" />
      </div>
      <div v-show="!displayingProducts">
        <slot name="articles" />
      </div>
    </div>
  </div>
</template>

<script>
  import { tag } from '@Foundation/analyticsHandler/directives/tag';
  import { mapGetters } from 'vuex';

  export default {
    name: 'SearchFiltersTabs',
    directives: {
      tag
    },
    props: {
      productsLabel: { type: String, required: false, default: 'Products' },
      articlesLabel: { type: String, required: false, default: 'Articles' }
    },
    data() {
      return {
        displayingProducts: true
      };
    },
    computed: {
      ...mapGetters('searchFiltersStore', [
        'productsCount',
        'articlesCount'
      ])
    },
    methods: {
      displayProductsTab() {
        this.displayingProducts = true;
      },
      displayArticlesTab() {
        this.displayingProducts = false;
      }
    }
  };
</script>
